import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { User } from 'src/app/shared/models';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UsersService {
  private httpClient = inject(HttpClient);

  endpoint = `${environment.endpoint}/users`;

  getAll(fields: {
    page: number;
    limit?: number;
    filters?: any;
    orderBy?: keyof User;
    order?: 'ASC' | 'DESC';
  }): Observable<{
    data: User[];
    hasNextPage: boolean;
    length: number;
    page: number;
  }> {
    Object.keys(fields).forEach((key) => {
      const target = fields[key as keyof typeof fields];
      if (target === null || target === undefined) {
        delete fields[key as keyof typeof fields];
      }
      if (key === 'filters') {
        fields[key] = JSON.stringify(fields[key]);
      }
    });

    const params = new HttpParams({
      fromObject: fields,
    });

    return this.httpClient.get<{
      data: User[];
      hasNextPage: boolean;
      length: number;
      page: number;
    }>(`${this.endpoint}`, {
      params,
    });
  }

  create(user: User): Observable<User> {
    return this.httpClient.post<User>(`${this.endpoint}`, user);
  }

  update(id: string, user: Partial<User>): Observable<User> {
    return this.httpClient.patch<User>(`${this.endpoint}/${id}`, user);
  }

  delete(id: string): Observable<void> {
    return this.httpClient.delete<void>(`${this.endpoint}/${id}`);
  }
}
